import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToHash = () => {
    const location = useLocation();
    const prevLocation = useRef(location);

    useEffect(() => {
        // If this is the exact same location object as when the component mounted, 
        // it means this is the initial page load (or a Strict Mode remount).
        // We skip scrollTo(0,0) here so the browser can natively restore scroll position on refresh.
        if (prevLocation.current === location) {
            if (location.hash) {
                const id = location.hash.replace('#', '');
                const element = document.getElementById(id);
                if (element) {
                    setTimeout(() => {
                        element.scrollIntoView({ behavior: 'smooth' });
                    }, 100);
                }
            }
            return;
        }

        // On actual navigation, update the ref and handle scroll
        prevLocation.current = location;

        if (!location.hash) {
            if (location.state?.preventScrollReset) {
                return;
            }
            window.scrollTo(0, 0);
            return;
        }

        const id = location.hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
            setTimeout(() => {
                element.scrollIntoView({ behavior: 'smooth' });
            }, 100);
        }
    }, [location]);

    return null;
};

export default ScrollToHash;
